import React from 'react';
import { Textarea } from 'rebass';

import config from 'frontend/config';

const RaidbotsTextarea = ({ ...props }) => (
  <Textarea
    color={config.color}
    backgroundColor={config.colors.primary}
    {...props}
  />
);

export default RaidbotsTextarea;
